import React from "react";

export default function SideProductAddToCart(props) {
  // PROPS COMING FROM SideProductModalContent
  const {
    readyToAddNew,
    addToCartHandler,
    choosen,
    variantAlert,
    index,
    alertRef,
    isDiscountValid,
  } = props;

  return (
    <>
      <button
        type="button"
        disabled={readyToAddNew ? false : true}
        className="side-products-button"
        onClick={() => {
          addToCartHandler(
            choosen.productId,
            choosen.sku,
            choosen.freeProductId,
            choosen.freeProductSkus,
            choosen.buyOneGetOneFree,
            index,
            "",
            "",
            isDiscountValid && choosen.timeLimitedDiscount.discountAmount
          );
        }}
      >
        Sepete Ekle
      </button>

      {variantAlert.message && variantAlert.index === index && (
        <button
          className="fs1 red-col txtcenter rad2-5r marupsideq padq lighterredbck border-none pointer"
          type="button"
          onClick={() =>
            alertRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            })
          }
        >
          <i className="fas fa-chevron-double-up fs1 red-col"></i>{" "}
          {variantAlert.message}
        </button>
      )}
    </>
  );
}
